<template>
  <div id="app">
    <router-view></router-view>
    <div
      class="audio"
      @click="play"
      :class="{ audio2: isplay }"
      ref="playButton"
      v-if="music"
    >
      <audio ref="audio" loop="loop" autoplay="autoplay" id="audio" muted>
        <source :src="music" type="audio/mpeg" />
      </audio>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isplay: true,
      music: "",
    };
  },
  methods: {
    // 控制音乐播放
    play() {
      console.log(this.$refs.audio.muted);
      if (this.$refs.audio.muted === false) {
        this.$refs.audio.play();
        this.$refs.audio.muted = true;
        this.isplay = false;
      } else {
        this.$refs.audio.play();
        this.$refs.audio.muted = false;
        this.isplay = true;
      }
    },
    // 音乐播放
    autoPlayMusic() {
      // 自动播放音乐效果，解决浏览器或者APP自动播放问题
      var audio = document.getElementById("audio");
      function musicInBrowserHandler() {
        audio.play();
        document.body.removeEventListener("touchstart", musicInBrowserHandler);
      }
      document.body.addEventListener("touchstart", musicInBrowserHandler);

      // 自动播放音乐效果，解决微信自动播放问题
      function musicInWeixinHandler() {
        audio.play();
        document.addEventListener(
          "WeixinJSBridgeReady",
          function () {
            audio.play();
          },
          false
        );
        document.removeEventListener("DOMContentLoaded", musicInWeixinHandler);
      }
      document.addEventListener("DOMContentLoaded", musicInWeixinHandler);
    },
    getMusic() {
      this.$http({
        url: this.$http.adornUrl(
          "/api/game/front/setting/code/" + this.$store.state.gameCode
        ),
        method: "get",
      }).then((res) => {
        console.log(res.data.data);
        this.$store.state.settingData = res.data.data
        res.data.data.bgm
          ? (this.music = window.SITE_CONFIG.imageRootUrl + res.data.data.bgm)
          : console.log("无背景音乐");
      });
    },
  },
  mounted() {
    this.getMusic();
    this.$nextTick(() => {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //如果输出结果是true就判定是android终端或者uc浏览器
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //根据输出结果true或者false来判断ios终端
      //!!双叹号一般用来将后面的表达式转换为布尔型的数据（boolean）
      if (isiOS) {
        // this.play();
      }
      // this.autoPlayMusic();
    });
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  overflow: hidden;
}
.audio {
  position: fixed;
  top: 6%;
  right: 6%;
  height: 0.6rem;
  width: 0.6rem;
  background: url("assets/images/guan.png") 0 0/100% 100% no-repeat;
}
.audio2 {
  background: url("assets/images/kai.png") 0 0/100% 100% no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/App.vue